import BaseCardBehavior from './BaseCardBehavior';

export default class LockCardBehavior extends BaseCardBehavior {
    public isPlayable(): boolean {
        return false;
    }
}
